// @flow
import { Helper, Loading } from "components";
import { messagesCcn, messagesHistory } from "constantes";
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { LocalStorage } from "services";
import {
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    GridColumn,
    Header,
    Icon,
    Message,
    Modal,
    Segment,
} from "semantic-ui-react";
import { capitalize, isEmptyObject, setMessage } from "tools";

import "./Ccn.scss";

type Props = {
    consumers: any,
    location: any,
    match: any,
    history: any,
};

type State = {
    active: boolean,
    loading: boolean,
    error: boolean,
    ccn: any,
    authorizedParts: Array<string>,
    uid?: string,
    organizationId?: string,
    issuer?: string,
    message: any,
    modalRedirectFrom: boolean,
    modalRedirectTo: boolean,
};

const paths = {
    redirect: "/recherche/ccn",
};

/**
 * Ccn Container
 * @author Tomasz tpr@deltacode.fr
 * @memberof Containers
 * @extends {React.Component}
 * @description Ccn container
 */
class Ccn extends Component<Props, State> {
    /**
     * @constructor
     * @param { Object } props Props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            active: false,
            loading: false,
            error: false,
            modalRedirectFrom: false,
            modalRedirectTo: false,
            ccn: {},
            authorizedParts: [],
            message: {},
        };
    }
    async componentDidMount() {
        /**
         * @instance
         * @async
         * @memberof Containers.Ccn
         * @method componentDidMount
         * @return { Void }
         */
        const authorizedParts = await LocalStorage.getItem("authorizedParts");
        const uid = await LocalStorage.getItem("uid");
        const organizationId = await LocalStorage.getItem("organizationId");
        const issuer = await LocalStorage.getItem("issuer");

        await this.setState({
            authorizedParts: authorizedParts,
            uid: uid,
            organizationId: organizationId,
            issuer: issuer,
        });
        if (!this.props.location.state) {
            this.props.history.push(paths.redirect);
        } else {
            this.getCcn();
        }
    }

    async componentDidUpdate(previousProps: any, previousState: any) {
        /**
         * @instance
         * @method componentDidUpdate
         * @memberof Widgets.WidgetBlock
         * @return { Void }
         */
        if (this.props.location.state.id !== previousProps.location.state.id) {
            await this.setState({
                loading: false,
            });
            this.getCcn();
        }
    }

    getStatus = async () => {
        /**
         * @instance
         * @async
         * @method getStatus
         * @memberof Components.WithRouterHeader
         * @description Get favorit status
         * @return { Void }
         */
        const { favorites } = this.props.consumers;
        if (this.props.history.location.state) {
            const { scope } = this.props.location.state;
            try {
                const id = this.props.location.state.id;
                const active = await favorites.inFavorites(scope, id);
                await this.setState({
                    error: false,
                    active: active,
                });
            } catch (error) {
                await this.setState({
                    error: true,
                });
            }
        } else {
            await this.setState({
                active: false,
            });
        }
    };

    handleToogleFavorits = async () => {
        /**
         * @instance
         * @async
         * @method handleToogleFavorits
         * @memberof Components.WithRouterHeader
         * @description Update favorit status
         * @return { Void }
         */
        const { favorites } = this.props.consumers;
        const data = {
            id: this.props.location.state.id,
            idcc: this.props.location.state.idcc,
            title: this.props.location.state.title,
            description: this.props.location.state.description,
        };
        const { scope } = this.props.location.state;
        await this.setState({
            active: !this.state.active,
        });
        await favorites.toogleFavorites(scope, data);
    };

    handleModalRedirectFromOpen = () => {
        /**
         * @instance
         * @async
         * @method handleModalOpen
         * @memberof Containers.CustomComponent
         * @description Open confirmation modal
         * @return { Void }
         */
        this.setState({ modalRedirectFrom: true });
    };

    handleModalRedirectFromClose = () => {
        /**
         * @instance
         * @async
         * @method handleModalClose
         * @memberof Containers.CustomComponent
         * @description Close confirmation modal
         * @return { Void }
         */
        this.setState({ modalRedirectFrom: false });
    };

    handleModalRedirectToOpen = () => {
        /**
         * @instance
         * @async
         * @method handleModalOpen
         * @memberof Containers.CustomComponent
         * @description Open confirmation modal
         * @return { Void }
         */
        this.setState({ modalRedirectTo: true });
    };

    handleModalRedirectToClose = () => {
        /**
         * @instance
         * @async
         * @method handleModalClose
         * @memberof Containers.CustomComponent
         * @description Close confirmation modal
         * @return { Void }
         */
        this.setState({ modalRedirectTo: false });
    };

    getCcn = async () => {
        const id = this.props.location.state.id;
        const { ccns, history } = this.props.consumers;
        const { organizationId } = this.state;
        if(organizationId) await this.getStatus();
        let ccn = await ccns.getCcn(id);
        const attachedRefs = ccn.redirectTo
            ? ccn.redirectTo.filter(
                (elm) =>
                    elm.type === "attached" ||
                    elm.type === "attachedMerged" ||
                    elm.type === "replacedPartial"
            )
            : [];
        const attachedCcns = attachedRefs.length
            ? await ccns.search(
                `ref=${attachedRefs.map((elm) => elm.ref).join(",")}`,
                "dispositions,_widgets,_structure,_metadata,ref,idcc"
            )
            : [];
        // If ccn has redrectFrom / redrectTo
        let localCcns = await ccns.getLocalCcns();
        if (!Object.keys(localCcns).length) {
            const response = await ccns.search();
            localCcns = await ccns.setLocalCcns(response);
        }
        try {
            if (ccn) {
                if (ccn.redirectTo) {
                    // Get redirects of type attached to get there new dispositions
                    const redirects = ccn.redirectTo.filter(
                        (redirect) =>
                            redirect.type === "attached" ||
                            redirect.type === "attachedMerged" ||
                            redirect.type === "replacedPartial"
                    );
                    if (redirects.length) {
                        if (redirects.length === 1 && !redirects[0].from) {
                            // Complet redirection
                            ccn.dispositions = attachedCcns[0].dispositions;
                            ccn._widgets = attachedCcns[0]._widgets;
                            ccn._structure = attachedCcns[0]._structure;
                            ccn._metadata = attachedCcns[0]._metadata;
                        } else {
                            // Partial redirection
                            redirects.map((redirect, i) => {
                                if (!redirect.from.college) {
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions[redirect.to.disposition]
                                    )
                                        ccn.dispositions[
                                            redirect.from.disposition
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions[redirect.to.disposition];
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions[
                                        redirect.to.disposition
                                        ]
                                    )
                                        ccn._widgets.dispositions[
                                            redirect.from.disposition
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions[
                                            redirect.to.disposition
                                            ];
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[redirect.to.disposition]
                                    )
                                        ccn._structure[
                                            redirect.from.disposition
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[redirect.to.disposition];
                                } else {
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions[
                                        redirect.to.disposition
                                        ] &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions[redirect.to.disposition][
                                        redirect.to.college
                                        ]
                                    )
                                        ccn.dispositions[
                                            redirect.from.disposition
                                        ][
                                            redirect.from.college
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).dispositions[redirect.to.disposition][
                                            redirect.to.college
                                            ];
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions[
                                        redirect.to.disposition
                                        ] &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions[
                                        redirect.to.disposition
                                        ][redirect.to.college]
                                    )
                                        ccn._widgets.dispositions[
                                            redirect.from.disposition
                                        ][
                                            redirect.from.college
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._widgets.dispositions[
                                        redirect.to.disposition
                                        ][redirect.to.college];
                                    if (
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[redirect.to.disposition] &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[redirect.to.disposition]
                                            .colleges &&
                                        attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[redirect.to.disposition]
                                            .colleges[redirect.to.college]
                                    )
                                        ccn._structure[
                                            redirect.from.disposition
                                        ].colleges[
                                            redirect.from.college
                                        ] = attachedCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure[
                                            redirect.to.disposition
                                        ].colleges[redirect.to.college];
                                }
                            });
                        }
                    }
                }
                this.props.location.state.idcc = ccn.idcc;
                this.props.location.state.title = ccn.title;
                this.props.location.state.description = ccn.description;
                await ccns.setLocalCcn(ccn);
                await this.setState({
                    loading: true,
                    ccn: {
                        ...ccn,

                        ...(ccn.redirectTo && {
                            redirectTo: ccn.redirectTo.map((redirect, i) => {
                                return {
                                    ...redirect,
                                    _structure: localCcns.find(
                                        (elm) => elm.ref === redirect.ref
                                    )._structure,
                                    title: localCcns.find(
                                        (elm) => elm.ref === redirect.ref
                                    ).title,
                                    description: localCcns.find(
                                        (elm) => elm.ref === redirect.ref
                                    ).description,
                                };
                            }),
                        }),
                        ...(ccn.redirectFrom && {
                            redirectFrom: ccn.redirectFrom.map(
                                (redirect, i) => {
                                    return {
                                        ...redirect,
                                        _structure: localCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        )._structure,
                                        title: localCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).title,
                                        description: localCcns.find(
                                            (elm) => elm.ref === redirect.ref
                                        ).description,
                                    };
                                }
                            ),
                        }),
                    },
                });
            }
        } catch (error) {
            this.setState({
                error: true,
                message: setMessage(messagesCcn, error.status),
            });
        }
        try {
            this.state.organizationId &&
                (await history.addToHistory("ccn", {
                    id: id,
                    idcc: ccn.idcc,
                    title: ccn.title,
                    description: ccn.description,
                }));
        } catch (error) {
            this.setState({
                error: true,
                message: setMessage(messagesHistory, error.status),
            });
        }
    };
    render() {
        /**
         * @instance
         * @method render
         * @memberof Containers.Ccn
         * @return { String } JSX
         */
        const {
            active,
            loading,
            error,
            ccn,
            message,
            authorizedParts,
            modalRedirectFrom,
            modalRedirectTo,
            uid,
            organizationId,
            issuer,
        } = this.state;
        const { id } = this.props.match.params;
        return (
            <Fragment>
                <Grid columns={1} className="Ccn page">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment basic>
                                {!isEmptyObject(message) && (
                                    <Message
                                        color={message.color}
                                        content={message.text}
                                    />
                                )}
                            </Segment>
                            <Helper />
                            {uid && organizationId && issuer === "hub" && !isEmptyObject(ccn) && (
                                <div
                                    style={{
                                        textAlign: "right",
                                        paddingTop: "1em",
                                    }}
                                >
                                    <Button circular icon>
                                        <Icon
                                            onClick={this.handleToogleFavorits}
                                            name="heart"
                                            color={active ? "red" : "grey"}
                                        />{" "}
                                    </Button>
                                </div>
                            )}
                            <Header
                                as="h1"
                                color="grey"
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                IDCC {ccn.idcc} Brochure {ccn.brochure}
                            </Header>

                            {loading && !error ? (
                                <Fragment>
                                    <Header as="h2" textAlign="center">
                                        {capitalize(ccn.description)}
                                    </Header>

                                    {/*ccn.attachment && (
                                        <Header as="h4" textAlign="center">
                                            {capitalize(ccn.attachment)}
                                        </Header>
                                    )*/}
                                    {ccn.deleted && (
                                        <Message
                                            size="tiny"
                                            icon={<Icon name="warning sign" />}
                                            color="red"
                                            header={
                                                <Header
                                                    as="h5"
                                                    textAlign="center"
                                                >{`${ccn.deletedComment} `}</Header>
                                            }
                                        />
                                    )}
                                    {/*RedirectTo annexedMerged and annexedOrphan (full or partial) */}
                                    {ccn.redirectTo &&
                                        ccn.redirectTo.filter(
                                            (elm) =>
                                                elm.type === "annexedMerged" || elm.type === "annexedOrphan"
                                        ).length !== 0 && (
                                            <div
                                                style={{
                                                    marginTop: "1em",
                                                    width: "80%",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                    Cette CCN est annexée dans
                                                    la CCN :
                                                </p>
                                                <Card
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1em",
                                                    }}
                                                >
                                                    <CardContent>
                                                        {ccn.redirectTo
                                                            .filter(
                                                                (elm) =>
                                                                    elm.type ===
                                                                    "annexedMerged" || elm.type ===
                                                                    "annexedOrphan"
                                                            )
                                                            .map(
                                                                (
                                                                    redirect,
                                                                    i
                                                                ) => {
                                                                    return (
                                                                        <Link
                                                                            className="link medium"
                                                                            key={
                                                                                i
                                                                            }
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        redirect.idcc,
                                                                                    id:
                                                                                        redirect.ref,
                                                                                    title: redirect.title,
                                                                                    description: redirect.description,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${redirect.ref}`,
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <Icon
                                                                                name="chevron right"
                                                                                color="grey"
                                                                            />
                                                                            IDCC{" "}
                                                                            {
                                                                                redirect.idcc
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                redirect.description
                                                                            }
                                                                            {redirect.to && (
                                                                                <>
                                                                                    <span
                                                                                        style={{
                                                                                            color:
                                                                                                "lightgrey",
                                                                                            fontSize:
                                                                                                "18px",
                                                                                            marginLeft:
                                                                                                "5px",
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        {
                                                                                            redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .to
                                                                                                    .disposition
                                                                                            ]
                                                                                                .title
                                                                                        }
                                                                                        {
                                                                                            ""
                                                                                        }
                                                                                        {redirect
                                                                                            .to
                                                                                            .college &&
                                                                                            ` - ${redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .to
                                                                                                    .disposition
                                                                                            ]
                                                                                                .colleges[
                                                                                            redirect
                                                                                                .to
                                                                                                .college
                                                                                            ]
                                                                                            }`}
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </Link>
                                                                    );
                                                                }
                                                            )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        )}

                                    {/*RedirectTo attachedMerged (full or partial) */}
                                    {ccn.redirectTo &&
                                        ccn.redirectTo.filter(
                                            (elm) =>
                                                elm.type === "attachedMerged"
                                        ).length !== 0 && (
                                            <div
                                                style={{
                                                    marginTop: "1em",
                                                    width: "80%",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                    Cette CCN à été fusionnée
                                                    pour créer la CCN :
                                                </p>
                                                <Card
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1em",
                                                    }}
                                                >
                                                    <CardContent>
                                                        {ccn.redirectTo
                                                            .filter(
                                                                (elm) =>
                                                                    elm.type ===
                                                                    "attachedMerged"
                                                            )
                                                            .map(
                                                                (
                                                                    redirect,
                                                                    i
                                                                ) => {
                                                                    return (
                                                                        <Link
                                                                            className="link medium"
                                                                            key={
                                                                                i
                                                                            }
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        redirect.idcc,
                                                                                    id:
                                                                                        redirect.ref,
                                                                                    title: redirect.title,
                                                                                    description: redirect.description,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${redirect.ref}`,
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <Icon
                                                                                name="chevron right"
                                                                                color="grey"
                                                                            />
                                                                            IDCC{" "}
                                                                            {
                                                                                redirect.idcc
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                redirect.description
                                                                            }
                                                                            {redirect.to && (
                                                                                <>
                                                                                    <span
                                                                                        style={{
                                                                                            color:
                                                                                                "lightgrey",
                                                                                            fontSize:
                                                                                                "18px",
                                                                                            marginLeft:
                                                                                                "5px",
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        {
                                                                                            redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .to
                                                                                                    .disposition
                                                                                            ]
                                                                                                .title
                                                                                        }
                                                                                        {
                                                                                            ""
                                                                                        }
                                                                                        {redirect
                                                                                            .to
                                                                                            .college &&
                                                                                            ` - ${redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .to
                                                                                                    .disposition
                                                                                            ]
                                                                                                .colleges[
                                                                                            redirect
                                                                                                .to
                                                                                                .college
                                                                                            ]
                                                                                            }`}
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </Link>
                                                                    );
                                                                }
                                                            )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        )}

                                    {/*RedirectTo attached (full or partial) */}
                                    {ccn.redirectTo &&
                                        ccn.redirectTo.filter(
                                            (elm) =>
                                                elm.type === "attached" ||
                                                elm.type === "replacedPartial"
                                        ).length !== 0 && (
                                            <>
                                                {ccn.redirectTo.length === 1 &&
                                                    !ccn.redirectTo[0].from ? (
                                                    <Container textAlign="center">
                                                        <Message
                                                            size="tiny"
                                                            icon={
                                                                <Icon name="warning sign" />
                                                            }
                                                            color="orange"
                                                            header={
                                                                <Grid
                                                                    centered
                                                                    verticalAlign="middle"
                                                                >
                                                                    <GridColumn
                                                                        mobile={
                                                                            16
                                                                        }
                                                                        tablet={
                                                                            12
                                                                        }
                                                                        computer={
                                                                            12
                                                                        }
                                                                    >
                                                                        <Header
                                                                            as="h5"
                                                                            textAlign="center"
                                                                        >{`À ce jour s'appliquent les garanties ci-dessous de la/les CCN de rattachement(s)`}</Header>
                                                                    </GridColumn>
                                                                    <GridColumn
                                                                        mobile={
                                                                            10
                                                                        }
                                                                        tablet={
                                                                            4
                                                                        }
                                                                        computer={
                                                                            4
                                                                        }
                                                                    >
                                                                        <Link
                                                                            className="ui basic button"
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        ccn
                                                                                            .redirectTo[0]
                                                                                            .idcc,
                                                                                    id:
                                                                                        ccn
                                                                                            .redirectTo[0]
                                                                                            .ref,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${ccn.redirectTo[0].ref}`,
                                                                            }}
                                                                        >
                                                                            Rattachée
                                                                            à
                                                                            l'IDCC{" "}
                                                                            {
                                                                                ccn
                                                                                    .redirectTo[0]
                                                                                    .idcc
                                                                            }
                                                                        </Link>
                                                                    </GridColumn>
                                                                </Grid>
                                                            }
                                                        />
                                                    </Container>
                                                ) : (
                                                    <>
                                                        <div
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                            }}
                                                        >
                                                            <Message
                                                                size="tiny"
                                                                icon={
                                                                    <Icon name="warning sign" />
                                                                }
                                                                color="orange"
                                                                header={
                                                                    <Grid
                                                                        centered
                                                                        verticalAlign="middle"
                                                                    >
                                                                        <GridColumn
                                                                            mobile={
                                                                                16
                                                                            }
                                                                            tablet={
                                                                                12
                                                                            }
                                                                            computer={
                                                                                12
                                                                            }
                                                                        >
                                                                            <Header
                                                                                as="h5"
                                                                                textAlign="center"
                                                                            >{`À ce jour s'appliquent les garanties ci-dessous de la/les CCN de rattachement(s)`}</Header>
                                                                        </GridColumn>
                                                                        <GridColumn
                                                                            mobile={
                                                                                10
                                                                            }
                                                                            tablet={
                                                                                4
                                                                            }
                                                                            computer={
                                                                                4
                                                                            }
                                                                        >
                                                                            <Button
                                                                                className="ui basic button"
                                                                                onClick={
                                                                                    this
                                                                                        .handleModalRedirectToOpen
                                                                                }
                                                                            >
                                                                                Voir
                                                                                les
                                                                                rattachements
                                                                            </Button>
                                                                        </GridColumn>
                                                                    </Grid>
                                                                }
                                                            />
                                                        </div>
                                                        <Modal
                                                            closeIcon
                                                            onClose={
                                                                this
                                                                    .handleModalRedirectToClose
                                                            }
                                                            open={
                                                                modalRedirectTo
                                                            }
                                                            centered={false}
                                                        >
                                                            <Modal.Content
                                                                scrolling
                                                            >
                                                                <Container>
                                                                    {ccn.redirectTo
                                                                        .filter(
                                                                            (
                                                                                elm
                                                                            ) =>
                                                                                elm.type ===
                                                                                "attached" ||
                                                                                elm.type ===
                                                                                "replacedPartial"
                                                                        )
                                                                        .map(
                                                                            (
                                                                                redirect,
                                                                                i
                                                                            ) => {
                                                                                return (
                                                                                    <Link
                                                                                        className="link medium"
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                        to={{
                                                                                            state: {
                                                                                                idcc:
                                                                                                    redirect.idcc,
                                                                                                id:
                                                                                                    redirect.ref,
                                                                                                title: redirect.title,
                                                                                                description: redirect.description,
                                                                                                scope:
                                                                                                    "ccn",
                                                                                            },
                                                                                            pathname: `/ccn/${redirect.ref}`,
                                                                                        }}
                                                                                        onClick={
                                                                                            this
                                                                                                .handleModalRedirectToClose
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                fontSize:
                                                                                                    "0.9em",
                                                                                                color:
                                                                                                    "gray",
                                                                                            }}
                                                                                        >
                                                                                            {redirect.from && (
                                                                                                <>
                                                                                                    {
                                                                                                        redirect
                                                                                                            ._structure[
                                                                                                            redirect
                                                                                                                .from
                                                                                                                .disposition
                                                                                                        ]
                                                                                                            .title
                                                                                                    }{" "}
                                                                                                    {redirect
                                                                                                        .from
                                                                                                        .college &&
                                                                                                        ` - ${redirect
                                                                                                            ._structure[
                                                                                                            redirect
                                                                                                                .from
                                                                                                                .disposition
                                                                                                        ]
                                                                                                            .colleges[
                                                                                                        redirect
                                                                                                            .from
                                                                                                            .college
                                                                                                        ]
                                                                                                        }`}
                                                                                                </>
                                                                                            )}{" "}
                                                                                            →{" "}
                                                                                            {redirect.to && (
                                                                                                <>
                                                                                                    {
                                                                                                        redirect
                                                                                                            ._structure[
                                                                                                            redirect
                                                                                                                .to
                                                                                                                .disposition
                                                                                                        ]
                                                                                                            .title
                                                                                                    }{" "}
                                                                                                    {redirect
                                                                                                        .to
                                                                                                        .college &&
                                                                                                        ` - ${redirect
                                                                                                            ._structure[
                                                                                                            redirect
                                                                                                                .to
                                                                                                                .disposition
                                                                                                        ]
                                                                                                            .colleges[
                                                                                                        redirect
                                                                                                            .to
                                                                                                            .college
                                                                                                        ]
                                                                                                        }`}{" "}
                                                                                                    <span
                                                                                                        style={{
                                                                                                            fontWeight:
                                                                                                                "bold",
                                                                                                        }}
                                                                                                    >
                                                                                                        IDCC{" "}
                                                                                                        {
                                                                                                            redirect.idcc
                                                                                                        }{" "}
                                                                                                        -{" "}
                                                                                                        {
                                                                                                            redirect.description
                                                                                                        }
                                                                                                    </span>
                                                                                                    <Icon
                                                                                                        name="chevron right"
                                                                                                        color="grey"
                                                                                                    />
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </Link>
                                                                                );
                                                                            }
                                                                        )}
                                                                </Container>{" "}
                                                            </Modal.Content>
                                                        </Modal>
                                                    </>
                                                )}
                                            </>
                                        )}

                                    {/*RedirectFrom annexedMerged (full or partial) */}
                                    {ccn.redirectFrom &&
                                        ccn.redirectFrom.filter(
                                            (elm) =>
                                                elm.type === "annexedMerged"
                                        ).length !== 0 && (
                                            <div
                                                style={{
                                                    marginTop: "1em",
                                                    width: "80%",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                    Cette CCN annexe les CCN
                                                    suivantes :
                                                </p>
                                                <Card
                                                    style={{
                                                        width: "100% ",
                                                        marginBottom: "1em",
                                                    }}
                                                >
                                                    <CardContent>
                                                        {ccn.redirectFrom
                                                            .filter(
                                                                (elm) =>
                                                                    elm.type ===
                                                                    "annexedMerged"
                                                            )
                                                            .map(
                                                                (
                                                                    redirect,
                                                                    i
                                                                ) => {
                                                                    return (
                                                                        <Link
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="link medium"
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        redirect.idcc,
                                                                                    id:
                                                                                        redirect.ref,
                                                                                    title: redirect.title,
                                                                                    description: redirect.description,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${redirect.ref}`,
                                                                            }}
                                                                        >
                                                                            IDCC{" "}
                                                                            {
                                                                                redirect.idcc
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                redirect.description
                                                                            }
                                                                            {redirect.from && (
                                                                                <>
                                                                                    <span
                                                                                        style={{
                                                                                            color:
                                                                                                "lightgrey",
                                                                                            fontSize:
                                                                                                "18px",
                                                                                            marginLeft:
                                                                                                "5px",
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        {
                                                                                            redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .title
                                                                                        }
                                                                                        {
                                                                                            ""
                                                                                        }
                                                                                        {redirect
                                                                                            .from
                                                                                            .college &&
                                                                                            ` - ${redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .colleges[
                                                                                            redirect
                                                                                                .from
                                                                                                .college
                                                                                            ]
                                                                                            }`}
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            <Icon
                                                                                name="chevron right"
                                                                                color="grey"
                                                                            />
                                                                        </Link>
                                                                    );
                                                                }
                                                            )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        )}

                                    {/*RedirectFrom annexedOrphan (full or partial) */}
                                    {ccn.redirectFrom &&
                                        ccn.redirectFrom.filter(
                                            (elm) =>
                                                elm.type === "annexedOrphan"
                                        ).length !== 0 && (
                                            <div
                                                style={{
                                                    marginTop: "1em",
                                                    width: "80%",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                    Cette CCN qui n’est pas porteuse de garantie annexe les CCN suivantes :
                                                </p>
                                                <Card
                                                    style={{
                                                        width: "100% ",
                                                        marginBottom: "1em",
                                                    }}
                                                >
                                                    <CardContent>
                                                        {ccn.redirectFrom
                                                            .filter(
                                                                (elm) =>
                                                                    elm.type ===
                                                                    "annexedOrphan"
                                                            ).sort((a, b) => a.idcc - b.idcc)
                                                            .map(
                                                                (
                                                                    redirect,
                                                                    i
                                                                ) => {
                                                                    return (
                                                                        <Link
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="link medium"
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        redirect.idcc,
                                                                                    id:
                                                                                        redirect.ref,
                                                                                    title: redirect.title,
                                                                                    description: redirect.description,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${redirect.ref}`,
                                                                            }}
                                                                        >
                                                                            IDCC{" "}
                                                                            {
                                                                                redirect.idcc
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                redirect.description
                                                                            }
                                                                            {redirect.from && (
                                                                                <>
                                                                                    <span
                                                                                        style={{
                                                                                            color:
                                                                                                "lightgrey",
                                                                                            fontSize:
                                                                                                "18px",
                                                                                            marginLeft:
                                                                                                "5px",
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        {
                                                                                            redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .title
                                                                                        }
                                                                                        {
                                                                                            ""
                                                                                        }
                                                                                        {redirect
                                                                                            .from
                                                                                            .college &&
                                                                                            ` - ${redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .colleges[
                                                                                            redirect
                                                                                                .from
                                                                                                .college
                                                                                            ]
                                                                                            }`}
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            <Icon
                                                                                name="chevron right"
                                                                                color="grey"
                                                                            />
                                                                        </Link>
                                                                    );
                                                                }
                                                            )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        )}
                                    {/*RedirectFrom attachedMerged (full or partial) */}
                                    {ccn.redirectFrom &&
                                        ccn.redirectFrom.filter(
                                            (elm) =>
                                                elm.type === "attachedMerged"
                                        ).length !== 0 && (
                                            <div
                                                style={{
                                                    marginTop: "1em",
                                                    width: "60%",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                    Cette CCN est issue de la
                                                    fusion des CCN :
                                                </p>
                                                <Card
                                                    style={{ width: "100% " }}
                                                >
                                                    <CardContent>
                                                        {ccn.redirectFrom
                                                            .filter(
                                                                (elm) =>
                                                                    elm.type ===
                                                                    "attachedMerged"
                                                            )
                                                            .map(
                                                                (
                                                                    redirect,
                                                                    i
                                                                ) => {
                                                                    return (
                                                                        <Link
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="link medium"
                                                                            to={{
                                                                                state: {
                                                                                    idcc:
                                                                                        redirect.idcc,
                                                                                    id:
                                                                                        redirect.ref,
                                                                                    title: redirect.title,
                                                                                    description: redirect.description,
                                                                                    scope:
                                                                                        "ccn",
                                                                                },
                                                                                pathname: `/ccn/${redirect.ref}`,
                                                                            }}
                                                                        >
                                                                            IDCC{" "}
                                                                            {
                                                                                redirect.idcc
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                redirect.description
                                                                            }
                                                                            {redirect.from && (
                                                                                <>
                                                                                    <span
                                                                                        style={{
                                                                                            color:
                                                                                                "lightgrey",
                                                                                            fontSize:
                                                                                                "18px",
                                                                                            marginLeft:
                                                                                                "5px",
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        {
                                                                                            redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .title
                                                                                        }
                                                                                        {
                                                                                            ""
                                                                                        }
                                                                                        {redirect
                                                                                            .from
                                                                                            .college &&
                                                                                            ` - ${redirect
                                                                                                ._structure[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .disposition
                                                                                            ]
                                                                                                .colleges[
                                                                                            redirect
                                                                                                .from
                                                                                                .college
                                                                                            ]
                                                                                            }`}
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            <Icon
                                                                                name="chevron right"
                                                                                color="grey"
                                                                            />
                                                                        </Link>
                                                                    );
                                                                }
                                                            )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        )}

                                    {/*RedirectFrom attached (full or partial) */}
                                    {ccn.redirectFrom &&
                                        ccn.redirectFrom.filter(
                                            (elm) =>
                                                elm.type === "attached" ||
                                                elm.type === "replacedPartial"
                                        ).length !== 0 && (
                                            <>
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        ...(ccn.redirectTo && {
                                                            marginTop: "0.5em",
                                                        }),
                                                    }}
                                                >
                                                    <Button
                                                        className="ui basic button"
                                                        onClick={
                                                            this
                                                                .handleModalRedirectFromOpen
                                                        }
                                                    >
                                                        Voir les CCN rattachées
                                                    </Button>
                                                </div>
                                                <Modal
                                                    closeIcon
                                                    onClose={
                                                        this
                                                            .handleModalRedirectFromClose
                                                    }
                                                    open={modalRedirectFrom}
                                                    centered={false}
                                                >
                                                    <Modal.Content scrolling>
                                                        <Container>
                                                            {ccn.redirectFrom
                                                                .filter(
                                                                    (elm) =>
                                                                        elm.type ===
                                                                        "attached" ||
                                                                        elm.type ===
                                                                        "replacedPartial"
                                                                )
                                                                .map(
                                                                    (
                                                                        redirect,
                                                                        i
                                                                    ) => {
                                                                        return (
                                                                            <Link
                                                                                className="link medium"
                                                                                key={
                                                                                    i
                                                                                }
                                                                                to={{
                                                                                    state: {
                                                                                        idcc:
                                                                                            redirect.idcc,
                                                                                        id:
                                                                                            redirect.ref,
                                                                                        title: redirect.title,
                                                                                        description: redirect.description,
                                                                                        scope:
                                                                                            "ccn",
                                                                                    },
                                                                                    pathname: `/ccn/${redirect.ref}`,
                                                                                }}
                                                                                onClick={
                                                                                    this
                                                                                        .handleModalRedirectFromClose
                                                                                }
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "0.9em",
                                                                                        color:
                                                                                            "gray",
                                                                                    }}
                                                                                >
                                                                                    {redirect.from && (
                                                                                        <>
                                                                                            {redirect
                                                                                                .from
                                                                                                .disposition && (
                                                                                                    <>
                                                                                                        {
                                                                                                            redirect
                                                                                                                ._structure[
                                                                                                                redirect
                                                                                                                    .from
                                                                                                                    .disposition
                                                                                                            ]
                                                                                                                .title
                                                                                                        }
                                                                                                    </>
                                                                                                )}{" "}
                                                                                            {redirect
                                                                                                .from
                                                                                                .college &&
                                                                                                ` - ${redirect
                                                                                                    ._structure[
                                                                                                    redirect
                                                                                                        .from
                                                                                                        .disposition
                                                                                                ]
                                                                                                    .colleges[
                                                                                                redirect
                                                                                                    .from
                                                                                                    .college
                                                                                                ]
                                                                                                }`}{" "}
                                                                                        </>
                                                                                    )}
                                                                                    <span
                                                                                        style={{
                                                                                            fontWeight:
                                                                                                "bold",
                                                                                        }}
                                                                                    >
                                                                                        IDCC{" "}
                                                                                        {
                                                                                            redirect.idcc
                                                                                        }{" "}
                                                                                        -{" "}
                                                                                        {
                                                                                            redirect.description
                                                                                        }
                                                                                    </span>
                                                                                    {redirect.to && (
                                                                                        <>
                                                                                            {" "}
                                                                                            →{" "}
                                                                                            {
                                                                                                redirect
                                                                                                    ._structure[
                                                                                                    redirect
                                                                                                        .to
                                                                                                        .disposition
                                                                                                ]
                                                                                                    .title
                                                                                            }{" "}
                                                                                            {redirect
                                                                                                .to
                                                                                                .college &&
                                                                                                ` - ${redirect
                                                                                                    ._structure[
                                                                                                    redirect
                                                                                                        .to
                                                                                                        .disposition
                                                                                                ]
                                                                                                    .colleges[
                                                                                                redirect
                                                                                                    .to
                                                                                                    .college
                                                                                                ]
                                                                                                }`}
                                                                                        </>
                                                                                    )}
                                                                                    <Icon
                                                                                        name="chevron right"
                                                                                        color="grey"
                                                                                    />
                                                                                </div>
                                                                            </Link>
                                                                        );
                                                                    }
                                                                )}
                                                        </Container>{" "}
                                                    </Modal.Content>
                                                </Modal>
                                            </>
                                        )}

                                    {Object.keys(ccn._structure)
                                        .sort()
                                        .reverse()
                                        .map((disposition, index) => {
                                            const element =
                                                ccn._structure[disposition];
                                            return (
                                                <Fragment key={index}>
                                                    <Header
                                                        as="h3"
                                                        content={element.title}
                                                        className="color-default"
                                                    />
                                                    {Object.keys(
                                                        element["colleges"]
                                                    ).map((college, index) => {
                                                        let color = "green";
                                                        let condition = false;
                                                        if (
                                                            ccn.dispositions &&
                                                            ccn.dispositions[
                                                            disposition
                                                            ]
                                                        ) {
                                                            if (
                                                                ccn
                                                                    .dispositions[
                                                                disposition
                                                                ][college]
                                                            ) {
                                                                color =
                                                                    "yellow";
                                                                condition = true;
                                                                if (
                                                                    ccn
                                                                        .dispositions[
                                                                    disposition
                                                                    ][college][
                                                                    "assureurs"
                                                                    ]
                                                                )
                                                                    color =
                                                                        "orange";
                                                                if (
                                                                    ccn
                                                                        .dispositions[
                                                                        disposition
                                                                    ][college]
                                                                        .agreementType
                                                                ) {
                                                                    if (
                                                                        ccn
                                                                            .dispositions[
                                                                            disposition
                                                                        ][
                                                                            college
                                                                        ]
                                                                            .agreementType ===
                                                                        "Sans accord"
                                                                    ) {
                                                                        color =
                                                                            "green";
                                                                        condition = false;
                                                                    } else if (
                                                                        ccn
                                                                            .dispositions[
                                                                            disposition
                                                                        ][
                                                                            college
                                                                        ]
                                                                            .agreementType ===
                                                                        "Sans accord mais obligations à minima"
                                                                    ) {
                                                                        color =
                                                                            "green";
                                                                        condition = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        if (
                                                            ccn._metadata &&
                                                            ccn._metadata
                                                                .dispositions[
                                                            disposition
                                                            ] &&
                                                            ccn._metadata
                                                                .dispositions[
                                                            disposition
                                                            ][college] &&
                                                            ccn._metadata
                                                                .dispositions[
                                                                disposition
                                                            ][college].unusable
                                                        ) {
                                                            color = "red";
                                                        }
                                                        /*if (ccn.dispositions &&
                                                            ccn.dispositions[disposition]
                                                        ) {
                                                            if (ccn.dispositions[disposition][college]) {
                                                                color = "yellow";
                                                                condition = true;
                                                                if (ccn.dispositions[disposition][college]["assureurs"]) color = "orange";
                                                                if (
                                                                    ccn._metadata &&
                                                                    ccn._metadata.dispositions[disposition] &&
                                                                    ccn._metadata.dispositions[disposition][college] &&
                                                                    ccn._metadata.dispositions[disposition][college].unusable
                                                                ) color = "red";
                                                                if (ccn.dispositions[disposition][college].noAgreements || ccn.dispositions[disposition][college].agreementType === "Sans accord"){
                                                                    color = "green"
                                                                    condition = false
                                                                }
                                                                if(ccn.dispositions[disposition][college].agreementType && ccn.dispositions[disposition][college].agreementType === "Sans accord mais obligations à minima"){
                                                                    condition = true
                                                                }
                                                            }
                                                        } else {
                                                            if (ccn._metadata &&
                                                                ccn._metadata.dispositions[disposition] &&
                                                                ccn._metadata.dispositions[disposition][college] &&
                                                                ccn._metadata.dispositions[disposition][college].unusable
                                                            ) color = "red";
                                                        }*/
                                                        return (
                                                            <Link
                                                                key={index}
                                                                className="link medium"
                                                                data-condition={
                                                                    ccn.deleted
                                                                        ? "active"
                                                                        : condition
                                                                            ? "inactive"
                                                                            : "active"
                                                                }
                                                                to={{
                                                                    pathname: `/ccn/${id}/detail`,
                                                                    state: {
                                                                        title:
                                                                            ccn.title,
                                                                        description:
                                                                            ccn.description,
                                                                        disposition: disposition,
                                                                        college: college,
                                                                        idcc:
                                                                            ccn.idcc,
                                                                        id: id,
                                                                        scope:
                                                                            "ccn",
                                                                    },
                                                                }}
                                                            >
                                                                <Icon
                                                                    name="circle"
                                                                    color={
                                                                        color
                                                                    }
                                                                />
                                                                {
                                                                    element[
                                                                    "colleges"
                                                                    ][college]
                                                                }
                                                                <Icon
                                                                    name="chevron right"
                                                                    color="grey"
                                                                />
                                                            </Link>
                                                        );
                                                    })}
                                                </Fragment>
                                            );
                                        })}
                                    {authorizedParts.includes(
                                        "entreprises"
                                    ) && (
                                            <Segment basic textAlign="center">
                                                <Link
                                                    to={{
                                                        pathname: `/entreprises/${id}`,
                                                        state: {
                                                            id: id,
                                                            idcc: ccn.idcc,
                                                            title: ccn.title,
                                                            description:
                                                                ccn.description,
                                                            codes: ccn.apes.map(
                                                                (elm) => elm.apeCode
                                                            ),
                                                        },
                                                    }}
                                                >
                                                    <Button
                                                        className="btn default"
                                                        size="large"
                                                    >
                                                        <Button.Content>
                                                            Voir les entreprises
                                                        </Button.Content>
                                                    </Button>
                                                </Link>
                                            </Segment>
                                        )}
                                </Fragment>
                            ) : (
                                <Fragment>
                                    {!error && <Loading title={`Chargement`} />}{" "}
                                </Fragment>
                            )}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Fragment>
        );
    }
}

export { Ccn };
